// Generated by purs version 0.14.1
"use strict";
var $foreign = require("./foreign.js");
var Web_Event_Internal_Types = require("../Web.Event.Internal.Types/index.js");
module.exports = {
    eventListener: $foreign.eventListener,
    addEventListener: $foreign.addEventListener,
    removeEventListener: $foreign.removeEventListener,
    dispatchEvent: $foreign.dispatchEvent
};
